export const resolvePropertyZip = subjectProperty =>
  subjectProperty?.address?.zip ?? subjectProperty?.address?.zipCode ?? null;
